<!--
 * @Author: fengzhongmei
 * @Date: 2020-04-26 10:18:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-15 11:35:50
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <Drawer :title="$t('调整授权')"
            v-model="show"
            width="380"
            :mask-closable="false"
            :styles="styles">
        <div class="authorityTree">
            <Tree style="margin-left:10px"
                  v-show="authorityData.length > 0"
                  :data="authorityData"
                  @on-check-change="checkChange"
                  show-checkbox></Tree>
            <no-data class="msg-no-data"
                     v-show="authorityData.length === 0"></no-data>
        </div>
        <div class="demo-drawer-footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Drawer>
</template>

<script>
import API from '@/service/api'
import noData from '@/views/components/basic/nodata.vue'
export default {
    name: 'authorize',
    components: {
        noData
    },
    data () {
        return {
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            checkedAll: [],
            show: false,
            loading: false,
            data: [],
            currData: [],
            checkedTree: [],
            authorityData: [],
            authorityDataBack: [],
            checkedTreeBack: []
        }
    },
    watch: {
        // 监控是否选择全部
        checkedTree (newval, oldval) {
            if ((oldval.length > 0 && oldval[0].title === '全部') || (newval.length > 0 && newval[0].title === '全部')) {
                this.checkedFun()
            }
        }
    },
    methods: {
        // 打开
        openModal (data) {
            this.cancel()
            this.show = true
            this.getDetails(data.policySid)
        },
        // 详情
        getDetails (id) {
            this.data.assertionIds = []
            this.axios.get(this.urlFormat(API.ACCESS_POLICES_ID, false, [id])).then(res => {
                this.loading = false
                this.data = res
                this.init()
            })
        },
        // 初始化授权数据
        init () {
            this.checkedTree = []
            this.checkedTreeBack = []
            this.authorityData = []
            this.loading = true
            this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ASSERTIONS, false), {
                params: {}
            }).then(res => {
                this.loading = false
                if (res.length > 0) {
                    for (let i = 0; i < res.length; i++) {
                        const assertionTypes = []
                        for (let j = 0; j < res[i].assertionTypes.length; j++) {
                            const assertions = []
                            for (let y = 0; y < res[i].assertionTypes[j].assertions.length; y++) {
                                const isChecked = (this.data.assertionIds.indexOf(res[i].assertionTypes[j].assertions[y].assertionSid)) !== -1 || this.data.assertionIds.indexOf(1) !== -1
                                if (isChecked) {
                                    this.checkedTreeBack.push(res[i].assertionTypes[j].assertions[y])
                                    this.checkedTree.push(res[i].assertionTypes[j].assertions[y])
                                }
                                assertions.push(
                                    {
                                        data: res[i].assertionTypes[j].assertions[y],
                                        id: res[i].assertionTypes[j].assertions[y].assertionSid,
                                        code: res[i].assertionTypes[j].assertions[y].opCode,
                                        title: res[i].assertionTypes[j].assertions[y].opName,
                                        expand: true,
                                        disabled: false,
                                        checked: isChecked,
                                        index: 3
                                    }
                                )
                            }
                            assertionTypes.push(
                                {
                                    id: res[i].assertionTypes[j].assertionType,
                                    title: res[i].assertionTypes[j].assertionTypeName,
                                    expand: true,
                                    disabled: false,
                                    checked: false,
                                    children: assertions
                                }
                            )
                        }
                        this.authorityData.push({
                            assertionSid: res[i].assertionSid || '',
                            expand: true,
                            id: res[i].nodeKey,
                            disabled: false,
                            title: res[i].serviceName,
                            children: assertionTypes
                        })
                    }
                }
                this.authorityDataBack = this.deepClone(this.authorityData)
            }).catch(e => {
                this.loading = false
            })
        },
        // 克隆
        deepClone (obj) {
            const _obj = JSON.stringify(obj)
            const objClone = JSON.parse(_obj)
            return objClone
        },
        // 选取全部，禁止操作全部之外的授权
        checkedFun () {
            if (this.checkedTree.length > 0 && this.checkedTree[0].title === '全部') {
                for (let i = 0; i < this.authorityData.length; i++) {
                    if (this.authorityData[i].title !== '全部') {
                        this.authorityData[i].checked = false
                        this.authorityData[i].disabled = true
                        for (const j in this.authorityData[i].children) {
                            this.authorityData[i].children[j].checked = false
                            this.authorityData[i].children[j].disabled = true
                            for (const item in this.authorityData[i].children[j].children) {
                                this.authorityData[i].children[j].children[item].checked = false
                                this.authorityData[i].children[j].children[item].disabled = true
                            }
                        }
                    } else {
                        this.authorityData[i].disabled = false
                    }
                }
            } else {
                // 取消全部，初始化最初权限
                this.authorityData = this.deepClone(this.authorityDataBack)
            }
        },
        checkChange (data) {
            this.checkedTree = data
        },
        getcheckedTree (data) {
            for (const i in data) {
                if (data[i].children && data[i].children.length > 0) {
                    this.getcheckedTree(data[i].children)
                } else if (Number(data[i].index) === 3) {
                    this.checkedAll.push(data[i].data)
                }
            }
        },
        // 提交
        submit () {
            this.checkedAll = []
            let data = []
            if (this.checkedTree.length > 0 && this.checkedTree[0].title === '全部') {
                // data = [{ assertionSid: 1, serviceCode: 'all', serviceName: '全部' }]
                this.getcheckedTree(this.authorityData)
                data = this.checkedAll
            } else {
                for (let i = 0; i < this.checkedTree.length; i++) {
                    if (Number(this.checkedTree[i].index) === 3) {
                        data.push(this.checkedTree[i].data)
                    } else if (this.checkedTree[i].assertionSid) {
                        data.push(this.checkedTree[i])
                    }
                }
            }
            const params = {
                policySid: this.data.policySid,
                resourceTypes: this.data.resourceTypes,
                assertions: data
            }
            this.loading = true
            this.axios.put(this.urlFormat(API.PUT_ACCESS_POLICES_CONFIG, false), params).then(res => {
                this.loading = false
                this.$emit('refresh')
                this.cancel()
            }).catch(e => {
                this.loading = false
            })
        },
        // 清空数据
        cancel () {
            this.checkedAll = []
            this.show = false
            this.data = []
            this.currData = []
            this.checkedTree = []
            this.authorityData = []
            this.authorityDataBack = []
        }
    }
}
</script>
<style lang="less" scoped>
.authorityTree {
    overflow: hidden;
    overflow-y: auto;
    height: calc(~'100% - 15px');
    border: 1px solid #eee;
    padding: 10px;
}
.demo-drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
}
</style>
